export default __webpack_public_path__ + "1b6065d29c1f8e0dca7a89501ab588f9.svg";